module.exports = __webpack_public_path__ + "static/media/air-filter-change-red.18b7d330.svg";